<template>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div id="homeSlider" class="carousel carousel-light slide" data-bs-ride="carousel">
                        <div class="carousel-indicators">
                            <button type="button" data-bs-target="#homeSlider" data-bs-slide-to="0" class="active"
                                aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#homeSlider" data-bs-slide-to="1"
                                aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#homeSlider" data-bs-slide-to="2"
                                aria-label="Slide 3"></button>
                        </div>
                        <div class="carousel-inner">
                            <div class="carousel-item active" data-bs-interval="2000">
                                <img src="@/assets/images/banner3.jpg" class="d-block w-100" alt="...">
                                <div class="carousel-caption d-none d-md-block">
                                    <h2>استخراج مصدرات الأحوال
                                        المدنية بأسرع وقت ..</h2>

                                    <p>إتاحة ماكينات إلكترونية لتمكين المواطنين من إستخراج
                                        مصدرات الأحوال المدنية بطريقة سهله وفى اسرع وقت.

                                    </p>

                                    <a href="#"  @click="ToSmartRecords" class="more_link">المزيد <i class="bi bi-arrow-left"></i></a>
                                </div>
                            </div>
                            <div class="carousel-item" data-bs-interval="2000">
                                <img src="@/assets/images/banner2.jpg" class="d-block w-100" alt="...">
                                <div class="carousel-caption d-none d-md-block">
                                    <h2>استخراج مصدرات الأحوال
                                        المدنية بأسرع وقت ..</h2>
                                    <p>إتاحة ماكينات إلكترونية لتمكين المواطنين من إستخراج
                                        مصدرات الأحوال المدنية بطريقة سهله وفى اسرع وقت.

                                    </p>
                                    <a @click="ToSmartRecords" href="#" class="more_link">المزيد <i class="bi bi-arrow-left"></i></a>
                                </div>
                            </div>
                            <div class="carousel-item" data-bs-interval="2000">
                                <img src="@/assets/images/innerImage.jpg" class="d-block w-100" alt="...">
                                <div class="carousel-caption d-none d-md-block">
                                    <h2>استخراج مصدرات الأحوال
                                        المدنية بأسرع وقت ..</h2>
                                    <p>إتاحة ماكينات إلكترونية لتمكين المواطنين من إستخراج
                                        مصدرات الأحوال المدنية بطريقة سهله وفى اسرع وقت.

                                    </p>
                                    <a href="#" @click="ToSmartRecords" class="more_link">المزيد <i class="bi bi-arrow-left"></i></a>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br/>
        </div>
    </section>

</template>

<script>
export default {
  name: 'HomeSliderComp',
  methods:{
    
    ToSmartRecords(){
        this.$router.push({name: 'smartrecords'})
    },
    
  }
  
}
</script>